import { Spesa } from '../Models/Spesa';
import { PrimaNotaStoreService } from '../_services/primaNota-store.service';
import { ApiRestService } from '../_services/api-rest.service';
import { Component, Input, OnInit } from '@angular/core';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service'
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Filtri_Spesa } from '../Models/Filtri_Spesa';
import {Permission} from "../../Login/_guards/Permission";

@Component({
  selector: 'app-lista-spese',
  templateUrl: './lista-spese.component.html'
})
export class ListaSpeseComponent implements OnInit {
  @Input() hasFiltri: boolean = true;
  @Input() isAddEnabled: boolean = true;
  @Input() isEditEnabled: boolean = true;
  type: string;
  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  Spese: Spesa[] = [];
  Selected: Spesa;
  @Input() Filtri: Filtri_Spesa = {page: 1, size: 10, competenza: false, pagare: false, pagate: false, periodo: false};
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server

  constructor(
    private ApiRestService: ApiRestService,
    private primanotaStore: PrimaNotaStoreService,
    private paginationService: ServerPaginationService,
    private route: ActivatedRoute,
    private router: Router,
    public permission: Permission,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.type = data['type'];
      this.refreshTable(1);
    });
    if(this.router.url== '/primanota/lista-spese') {
      this.primanotaStore.updateFilterEnable(true);
      this.primanotaStore.updateBackUrl("primanota/lista-spese");
    }
    this.subscriptions.add(this.primanotaStore.$filterEnabled.subscribe(data=> this.hasFiltri = data));
    this.subscriptions.add(this.primanotaStore.$spese.subscribe(data => {
      if (data && data != null) {
        this.collectionSize = data.total;
        this.Spese = data.data;
      }
    }))
  }
  Edit(item?: Spesa) {
    if(this.permission.isPermitted('gestione-spese')) {
      if (item) {
        this.ApiRestService.getSpesa(item).subscribe(data => {
          if (data) {
            this.primanotaStore.updateEditable(true);
            this.primanotaStore.updateAddable(false);
            this.primanotaStore.updateSpesaSelezionata(data);
            this.router.navigate([this.route.snapshot.queryParams[' primanota/spesa '] || 'primanota/spesa',]);
          }
        });
      } else {
        this.primanotaStore.updateEditable(false);
        this.primanotaStore.updateAddable(true);
        this.primanotaStore.updateSpesaSelezionata(new Spesa());
        this.router.navigate([this.route.snapshot.queryParams[' primanota/spesa '] || 'primanota/spesa',]);
      }
    }
  }
  delete(item: Spesa) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      this.ApiRestService.deleteSpesa({ id: item.id }).subscribe(() => this.refreshTable(this.newpagegenerated));
    }
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    console.log('pagina generata', this.newpagegenerated)
    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;
    if(this.hasFiltri) {
      this.primanotaStore.filterSpese(this.Filtri);
    } else if (this.type) {
      this.Filtri.cat_id = parseInt(this.type);
      this.primanotaStore.getSpese(this.Filtri);
    }else {
      this.primanotaStore.getSpese(this.Filtri);
    }
  }

}
